enum TaxClasstype {
  CORPORATION = 'CORPORATION',
  DISREGARDED_ENTITY = 'DISREGARDED_ENTITY',
  PARTNERSHIP = 'PARTNERSHIP',
}
export default TaxClasstype;
